import { IAudit } from '../../../../../../app/entities/Audit'
import {
  QUESTIONS,
  SECTIONS,
  TITLES,
  DAILY_VALIDATOR_ISSUES,
  VAN_ISSUES,
  TREAD_WORK_SHOE_DEFECTS,
} from '../../../../global/constants/audit-daily-dvir'
import { VIR_DAILY_PHOTOS } from '../../../../global/constants/virs'
import { IAuditSectionData } from '../../../../global/types/audit'

export function createDailyDvirAuditData(auditData: IAudit): {
  [key: string]: IAuditSectionData
} {
  return {
    [SECTIONS.van_external_images]: {
      title: TITLES[SECTIONS.van_external_images],
      imageTypes: [
        VIR_DAILY_PHOTOS.DRIVER_SIDE_OF_VAN,
        VIR_DAILY_PHOTOS.PASSENGER_SIDE_OF_VAN,
        VIR_DAILY_PHOTOS.FRONT_OF_VAN,
        VIR_DAILY_PHOTOS.REAR_OF_VAN,
      ],
      question: QUESTIONS[SECTIONS.van_external_images],
      defects: {
        [VAN_ISSUES.incorrectVan]: false,
        [VAN_ISSUES.damageIdentified]: false,
      },
    },
    [SECTIONS.daily_validator]: {
      title: TITLES[SECTIONS.daily_validator],
      imageTypes: [VIR_DAILY_PHOTOS.VALIDATOR_RESULT],
      question: QUESTIONS[SECTIONS.daily_validator],
      defects: {
        [DAILY_VALIDATOR_ISSUES.unableToReadScreen]: false,
        [DAILY_VALIDATOR_ISSUES.wrongPhoto]: false,
        [DAILY_VALIDATOR_ISSUES.redLight]: false,
        [DAILY_VALIDATOR_ISSUES.broken]: false,
        [DAILY_VALIDATOR_ISSUES.outOfCalibration]: false,
        [DAILY_VALIDATOR_ISSUES.noPhoto]: false,
      },
    },
    [SECTIONS.tread_work_shoe]: {
      title: TITLES[SECTIONS.tread_work_shoe],
      imageTypes: [VIR_DAILY_PHOTOS.TREAD_WORK_SHOE],
      question: QUESTIONS[SECTIONS.tread_work_shoe],
      defects: {
        [TREAD_WORK_SHOE_DEFECTS.no]: false,
        [TREAD_WORK_SHOE_DEFECTS.needsReplacement]: false,
      },
    },
  }
}
